// extracted by mini-css-extract-plugin
module.exports = {"section":"H_section__HXruv","space1":"H_space1__JtCoi"};